import { getAuthHeaders } from '../utils/authHeaders';
import { createFormPdf } from '../utils/formPdf';

const API_URL = 'https://app.pvslimited.co.uk/api';

const sendQCChecklistEmail = async (formData) => {
  try {
    const items = formData.checklistItems || {};
    const blob = await createFormPdf({
      title: 'FINAL QC CHECKLIST',
      ref: 'Ref: PVS-QCC-001 | Version: 1.0',
    }, (pdf) => {
      pdf.section('BASIC INFORMATION');
      pdf.field('Serial Number', formData.serialNumber);
      pdf.field('Customer Name', formData.customerName);
      pdf.field('Date Completed', formData.dateCompleted);
      pdf.field('QC Inspector', formData.qcInspector);
      pdf.field('Vessel Status', formData.vesselStatus);

      pdf.section('LPG TANK FINAL QUALITY CONTROL CHECKLIST');

      pdf.subsection('1. Vessel Identity & Paperwork');
      pdf.passFail('Serial number stamped & matches records', items.serialNumberStamped);
      pdf.passFail('Data plate present and legible', items.dataPlatePresent);
      pdf.passFail('Test certificate attached to vessel file', items.testCertificateAttached);

      pdf.subsection('2. External Condition');
      pdf.passFail('Paint finish complete (no pinholes, drips, rust bloom, or missed areas)', items.paintFinishComplete);
      pdf.passFail('RAL colour correct to customer specification', items.ralColourCorrect);
      pdf.passFail('Labels, decals & safety notices applied', items.labelsDecalsApplied);

      pdf.subsection('3. Fittings & Accessories');
      pdf.passFail('Valves installed and torqued to specification', items.valvesInstalledTorqued);
      pdf.passFail('Valves sealed/bunged to prevent ingress', items.valvesSealed);
      pdf.passFail('Relief valve present and test date marked', items.reliefValvePresent);
      pdf.passFail('Multivalve orientation correct', items.multivalveOrientation);
      pdf.passFail('Protective hood/cover securely installed, hinges & catches free-moving', items.protectiveHoodInstalled);

      pdf.subsection('4. Safety & Compliance');
      pdf.passFail('Tank safe for transport', items.tankSafeTransport);
      pdf.passFail('Lifting lugs, saddles, and base inspected for defects', items.liftingLugsInspected);
      pdf.passFail('No damage from handling/transport preparation', items.noDamageHandling);

      pdf.section('6. SIGN-OFF');
      pdf.field('Inspector Name', formData.inspectorName);
      pdf.field('Date', formData.inspectorDate);
      pdf.field('Signature', formData.inspectorSignature);
      pdf.field('Second Check (if applicable)', formData.secondCheck);

      if (formData.notes) {
        pdf.section('ADDITIONAL NOTES');
        pdf.longText('', formData.notes);
      }
    });

    const formDataToSend = new FormData();
    formDataToSend.append('file', blob, `QC_Checklist_${formData.serialNumber}_${Date.now()}.pdf`);
    formDataToSend.append('serialNumber', formData.serialNumber);
    formDataToSend.append('customerName', formData.customerName);
    formDataToSend.append('dateCompleted', formData.dateCompleted);
    formDataToSend.append('qcInspector', formData.qcInspector);
    formDataToSend.append('vesselStatus', formData.vesselStatus || 'Under Vacuum');
    formDataToSend.append('inspectorName', formData.inspectorName || '');
    formDataToSend.append('inspectorDate', formData.inspectorDate || '');
    formDataToSend.append('formType', 'qc-checklist');

    const response = await fetch(`${API_URL}/send-qc-checklist-email`, {
      method: 'POST',
      headers: getAuthHeaders(),
      body: formDataToSend,
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`HTTP error! status: ${response.status}, message: ${errorText}`);
    }

    return response.json();
  } catch (error) {
    console.error('Error in sendQCChecklistEmail:', error);
    throw error;
  }
};

export default sendQCChecklistEmail;
